const t=t=>Math.round(100*(t+Number.EPSILON))/100;export{t as default};
